// src/utils/platformLevel.ts
// Teacher Platform Level system — 6 levels based on cumulative platformScore.
// Scores reset annually; peak level is preserved in teacher.platformLevelPeak.
//
// Score events: +1 daily login, +5 tool session, +2 attendance save,
//               +1 grade entry, +10 resource created, +20 class created, +2 student added

export interface PlatformLevelInfo {
  level: 1 | 2 | 3 | 4 | 5 | 6;
  name: string;
  emoji: string;
  threshold: number;
  nextThreshold: number | null;
  perk: string;
}

export const PLATFORM_LEVELS: PlatformLevelInfo[] = [
  { level: 1, name: 'Newcomer',     emoji: '🌱', threshold: 0,     nextThreshold: 100,  perk: '—' },
  { level: 2, name: 'Explorer',     emoji: '🗺️', threshold: 100,   nextThreshold: 500,  perk: 'Extra classroom color theme unlocked' },
  { level: 3, name: 'Practitioner', emoji: '📚', threshold: 500,   nextThreshold: 1500, perk: 'Level badge visible in profile' },
  { level: 4, name: 'Expert',       emoji: '⭐', threshold: 1500,  nextThreshold: 4000, perk: 'Access to beta features' },
  { level: 5, name: 'Master',       emoji: '🎓', threshold: 4000,  nextThreshold: 8000, perk: 'Priority support flag' },
  { level: 6, name: 'Legend',       emoji: '🏛️', threshold: 8000,  nextThreshold: null, perk: 'Permanent featured profile recognition' },
];

/** Returns the PlatformLevelInfo for a given score. */
export const getTeacherPlatformLevel = (score: number): PlatformLevelInfo => {
  for (let i = PLATFORM_LEVELS.length - 1; i >= 0; i--) {
    if (score >= PLATFORM_LEVELS[i].threshold) return PLATFORM_LEVELS[i];
  }
  return PLATFORM_LEVELS[0];
};
